import { TranslationKey } from './en';

const ja: Record<TranslationKey, string> = {
  Name: '名前',
  Room: 'ルーム名',
  Join: '入室',
  BillingNotice: '予約時間前にJOINしても料金が発生します。予約時間にご利用ください。',
  MuteAudio: 'マイクをオフ',
  UnmuteAudio: 'マイクをオン',
  MuteVideo: 'カメラをオフ',
  UnmuteVideo: 'カメラをオン',
  ShareScreen: '画面を共有',
  StopSharingScreen: '画面共有を停止',
  ShareInProgress: '他の参加者が画面を共有中のため共有できません',
  ShareNotSupported: 'このブラウザーは画面共有に対応していません',
  EndCall: '通話を終了',
};

export default ja;
